import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {VendorMinInf} from '../../interfaces/common'
import {Level, VendorProductForPicker} from './level.picker.iface'
import {environment} from '../../../../environments/environment'

@Injectable()
export class LevelPickerService {

  private ADDR = `${environment.apiPrefix}`

  /**
   * Get Rate Level by Vendor Min Information (ID/category)
   * @param V - Vendor Min Inf.
   */
  getLevelRates(V: VendorMinInf): Promise<Level[]> {
    return new Promise<Level[]>((resolve, reject) => {
      this.http.get<{results: Level[]}>(`${this.ADDR}vendor/${V.category}/${V.vendorId}/rateLevel`)
        .subscribe((res) => {
          resolve(res.results)
        }, error => {
          reject(error)
        })
    })
  }

  getVendorProducts(V: VendorMinInf): Promise<VendorProductForPicker[]> {
    return new Promise<VendorProductForPicker[]>((resolve, reject) => {
      this.http.get<{results: VendorProductForPicker[]}>(`${this.ADDR}vendor/${V.category}/${V.vendorId}/product`)
        .subscribe((res) => {
          console.log('products: ', res)
          resolve(res.results)
        }, error => {
          reject(error)
        })
    })
  }

  constructor(
    private http: HttpClient
  ) {
  }
}
